import React from 'react'
import { encodeId, slugify } from '../../helper/helperFunction';
import { t } from 'i18next';
import { useCountryPrefix } from '../../routes/useCountryPrefix';
import { useTranslation } from 'react-i18next';
import CustomImageComponent from '../../components/CustomImageComponent';

const DeveloperProjectSec = (props) => {
    const { data, developersDetailData, onLoadMore, loadingMore } = props;
    const imageUrl = process.env.REACT_APP_IMAGE_URL;

    const { i18n } = useTranslation();
    const pathLang = i18n.language === "en" ? "" : i18n.language || "";

    const countryPrefix = useCountryPrefix();

    return (
        <>
            <section className="property-listing-section projects-section">
                <div className="container">
                    <div className="row">
                        {data?.items?.length &&
                            data?.items?.map((item, index) => (
                                <div className="col-md-6 col-lg-6" key={index}>
                                    <div className="flex-card">
                                        <a href={`/${countryPrefix}${pathLang ? `/${pathLang}` : ""}/developers/${slugify(developersDetailData?.developerName)}/project/${slugify(item.projectName)}/${encodeId((item.projectId))}`}>
                                            <div className="img-block">
                                                <CustomImageComponent src={item.thumbnailImage} alt={developersDetailData?.developerName} className={"img-fluid pro-img"} />
                                            </div>
                                        </a>
                                        <div className="content-block">
                                            <div className="pro-details share-block">
                                                <div className="left-blk">
                                                    {/* <span>Delivery in 2025</span> */}
                                                    <span>{item.status}</span>
                                                </div>
                                            </div>
                                            <div className="pro-details">
                                                <div className="left-blk">
                                                    <h4><a href={`/${countryPrefix}${pathLang ? `/${pathLang}` : ""}/developers/${slugify(developersDetailData?.developerName)}/project/${slugify(item.projectName)}/${encodeId((item.projectId))}`} >{item.projectName}</a></h4>
                                                    <p><CustomImageComponent src={"/assets/img/location-icon-pin.svg"} alt={"Location"} className={"img-fluid"} /> {item.location}</p>
                                                    <p>{item.description}</p>
                                                    {/* <a href={`project/${slugify(item.projectName)}/${encodeId((item.projectId))}`} className="theme-btn theme-btn-secondary">{t("book_now")}</a> */}
                                                    <a href={`/${countryPrefix}${pathLang ? `/${pathLang}` : ""}/developers/${slugify(developersDetailData?.developerName)}/project/${slugify(item.projectName)}/${encodeId((item.projectId))}`} className="theme-btn">{t("know_more")}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                    </div>
                    {data?.pageIndex < data?.totalPages && (
                        <div className="text-center mt-4 mb-4">
                            <button className="theme-btn theme-btn-secondary" onClick={onLoadMore} disabled={loadingMore}>
                                {loadingMore ? (<i className="fa fa-spinner fa-spin fa-2x ms-0"></i>) : (t("load_more"))}
                            </button>
                        </div>
                    )}
                </div>
            </section>

        </>
    )
}

export default DeveloperProjectSec